
import { Component, Ref, Watch, Vue, Model } from 'nuxt-property-decorator';

@Component
export default class OverlayElement extends Vue {
  @Ref() readonly hiddenHandle?: HTMLButtonElement;

  @Model('change', { type: Boolean, required: true }) readonly value!: boolean;

  callBackFocusElement: HTMLButtonElement | null = null;

  get innerValue(): boolean {
    return this.value;
  }

  set innerValue(value: boolean) {
    this.$emit('change', value);
  }

  @Watch('innerValue')
  async onInnerValueChange() {
    await this.$nextTick();
    if (this.innerValue) {
      this.hiddenHandle?.focus();
    } else {
      this.callBackFocusElement?.focus();
      this.callBackFocusElement = null;
    }
  }

  public setTargetElement(targetElement: HTMLButtonElement | EventTarget) {
    if (targetElement instanceof HTMLButtonElement) this.callBackFocusElement = targetElement;
  }

  public lastHandleFocusHandler() {
    this.hiddenHandle?.focus();
  }
}
